import i18n from 'config/i18n';

import { getLocale } from 'utils/date';

import { GridColumns } from '@mui/x-data-grid-pro';

const t = i18n.getFixedT(getLocale(), 'common');

const accountGroupColumnDefinitions = [
  {
    field: 'name',
    headerName: t('name'),
    type: 'string',
    flex: 1,
    align: 'left'
  }
] as GridColumns;

export default accountGroupColumnDefinitions;
